import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Subscription } from 'rxjs';

declare global {
	interface Window {
		dataLayer: any[];
		gtag: (...args: any[]) => void;
	}
}

@Injectable({
	providedIn: 'root'
})
export class AnalyticsService {
	
	public searchCategory: string = 'document_searched';
	public viewCategory: string = 'document_visited';
	public downloadCategory: string = 'document_downloaded';

	private userEventSubscription!: Subscription;

	private isLoaded: boolean = false;
	private serviceId: string | undefined = undefined;
	
	constructor(
		private userService: UserService
	) {
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if (event === 'userPrefsUpdate') {
				this.initialize(this.userService.user.gaTrackingID);
			}
		});
	}

	active(): boolean {
		return (typeof this.serviceId !== undefined && typeof window.gtag !== 'undefined');
	}

	initialize(serviceId?: string) {
		if (this.isLoaded || !serviceId) return;

		// Inject gtag.js (Replaces hard-coded index.html tag)
		const script = document.createElement('script');
		script.src = `https://www.googletagmanager.com/gtag/js?id=${serviceId}`;
		script.async = true;
		document.head.appendChild(script);

		// Initialize gtag
		window.dataLayer = window.dataLayer || [];
		function gtag(...args: any[]) {
			window.dataLayer.push(args);
		}

		window.gtag = gtag;

		gtag('js', new Date());
		gtag('config', serviceId);

		this.serviceId = serviceId;
		this.isLoaded = true;
	}

	trackEvent(eventName: string, category: string, params: any = {}): void {
		const tmp = this.userService.getLocalStorageData();
		if (this.active() && tmp?.gaCookieAllowed) {
			
			let eventParams = { 
				...params, 
				'username': this.userService.user.username,
				'userID': this.userService.user.id,
				'domain': this.userService.user.domain
			};
			
			window.gtag(eventName, category, eventParams);
		}
	}

	trackSearchCollectionEvent(query: string, facets: any[] = []): void {
		const collectionField = this.userService.user.collectionField;
		if (this.active() && collectionField?.length === 0) {
			facets.forEach((facet: any) => {
				if (facet.solrfieldname === collectionField) {
					const values = facet.value;
					this.trackEvent('event', this.searchCategory, {
						event_category: 'engagement',
						event_label: 'Searched in collection',
						net_search: query,
						collectionsOverlap: values.length,
					});

					values.forEach((v: any) => {
						this.trackEvent('event', this.searchCategory, {
							event_category: 'engagement',
							event_label: 'Searched in collection',
							search: query,
							collection: v.value,
							username: this.userService.user.username,
							userID: this.userService.user.id,
						});
					});
				}
			});
		}
	}
}
